<template>
  <div style="display: contents; white-space: nowrap;">
    <div v-if="!isReadOnly" style="white-space: nowrap;" class="mt-5">
      <div v-if="viItem.isFirst" dense style="display: inline-block;width:10px" />
      <v-icon v-if="viItem.isFirst" dense style="display: inline-block;">mdi-circle-double</v-icon>
      <!--<div v-if="viItem.isInterAxle" dense style="display: inline-block;width:50px" />-->
      <wrs-v-number v-model="model" :label="viItem.label" @input="emitInputEvent"
                    format="decimal" :errors="validationErrors"
                    stack-label outlined dense style="display: inline-block; width:110px">
      </wrs-v-number>
      <!--<div v-if="viItem.isInterAxle" dense style="display: inline-block;width:50px" />-->
      <v-icon dense style="display: inline-block;">mdi-circle-double</v-icon>
    </div>
    <div v-if="isReadOnly" style="white-space: nowrap;">
      <v-icon v-if="viItem.isFirst" dense style="display: inline-block;">mdi-circle-double</v-icon>
      <!--<div v-if="viItem.isInterAxle" dense style="display: inline-block;width:50px" />-->
      <div dense style="display: inline-block;width:5px" />
      <wrs-label label="" :hasLabel="false" :value="model | toMeterDecimal" style="display: inline-block;" />
      <!--<div v-if="viItem.isInterAxle" dense style="display: inline-block;width:50px" />-->
      <div dense style="display: inline-block;width:5px" />
      <v-icon dense style="display: inline-block;">mdi-circle-double</v-icon>
    </div>
  </div>
</template>
<script>
  // WrsSpacingItem.vue
  import WrsVuetifyNumber from '../../WrsVuetifyNumber.vue';
  import WrsLabel from '../../WrsLabel.vue';

  export default {
    components: {
      'wrs-v-number': WrsVuetifyNumber,
      'wrs-label': WrsLabel
    },
    props: {
      viItem: {
        type: Object,
        default: function () {
          return {
            isFirst: false,
            isVisible: false,
            value: 0,
            orderNumber: 0,
            axleOrderNumber: 0,
            minValue: 0,
            isInterAxle: false,
            requiredError: "",
            label: "",
            isRequired: false,
            error: "",
            hasError: false
          };
        },
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      model: {
        get() {
          return this.viItem.value;
        },
        set(value) {
          this.viItem.value = value;
        }
      },
      validationErrors() {
        const errors = [];

        this.checkForErrors(this.viItem);
        if (this.viItem.hasError) errors.push(this.viItem.error);

        return errors;

      },
    },
    methods: {
      checkForErrors: (vi) => {
        if (!vi.isVisible) {
          vi.hasError = false;
          vi.error = "";
          return;
        }

        if (vi.value == null || vi.value <= 0) {

          vi.hasError = true;
          vi.error = vi.requiredError;
          return;
        }

        vi.hasError = false;
        vi.error = "";
      },
      emitInputEvent: function () {
        this.$emit('input');
      }
    }
  }
</script>

